import auth from '../../services/auth'

export default {
  data() {
    return {
      taxIdNumber: undefined,
      password: undefined,
      errorMessage: undefined,
      email: null,
      loading: Promise.resolve(true),
      saveTaxId: false,
    }
  },
  created(){
    if(auth.getTaxId()){
      this.taxIdNumber = auth.getTaxId();
      this.saveTaxId = true;
    }
    if(auth.getPass()){
      this.password = auth.getPass();
      this.saveTaxId = true;
    }
    this.password = '';
  },
  mounted: function () {
    if (this.$route.query.sessionExpired) {
      $('body').removeClass('modal-open').css('padding-right', '0');
      $('.modal-backdrop').hide();
      this.errorMessage = 'Sua sessão expirou, por favor faça o login novamente';
    }
  },
  methods: {
    doLogin() {
      this.errorMessage = undefined;
      this.$validator.validateAll()
        .then(success => {
          let username = this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
          this.loading = auth.login(username, this.password, this.email)
            .then(user => {
              console.log("retorno login user ", user);
            auth.isGrouper(user.moveMaisId).then(isGrouper => {
              auth.saveIsGrouper(isGrouper.Agrupador);
            });
            auth.saveTaxIdNumber(this.taxIdNumber);
            auth.saveMoveMaisId(user.moveMaisId);
            if (user.otherSalesReference === 'REPOM') {
                this.$router.push({
                  name: 'repom'
                });
              } else {
                if(this.saveTaxId){
                  auth.saveTaxId(this.taxIdNumber, this.password);
                } else {
                  auth.deleteTaxId();
                }

                if (auth.getLoginTFA() == 'Y') {
                  this.$router.push({
                    name: 'choose-channel-interno',
                    params: { type: 'login' }
                  });
                } else {
                  this.$router.push({
                    name: 'plans',
                    query: { showPromotionalModal: true }
                  });
                }
              }
            })
            .catch(err => {

              this.errorMessage = err.status && err.data.status && err.data.status.message || "Erro do servidor.";
            });
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/login.js